import restCrudReducer from '../../../../np-crud/store/restCrudReducer';

const [crudInitialState, crudReducer] = restCrudReducer({
    pluginName: 'USER',
    entityName: 'USER',
});

const initialState = {
    ...crudInitialState,
    deletedExternalSystemSetting: {},
    deleting: false,
    saving: false,
    passwordExpired: true,
    edited: false
};
const reducer = (state = initialState, action) => {
    // Handle CRUD actions
    const newState = crudReducer(state, action);
    // If CRUD reducer handled the action
    if (newState !== null) {
        return newState;
    }

    // Handle other actions
    switch (action.type) {
        case 'USER|USER_PASSWORD_CHANGE_SUCCESS':
            return { ...state, passwordExpired: !action.password }
        case 'USER|USER_PERMISSION_CHANGE_SUCCESS':
            return { ...state, edited: !state.edited }
        case 'USER|CUSTOMERS_SAVE_SUCCESS':
            return { ...state, edited: true }
        case 'CLEAN_STATE':
            return { ...state, loaded: null }
        case 'CORE|LOGOUT_SUCCESS':
        case 'CORE|CORE_SET_ACTIVE_CUSTOMER_SUCCESS':
            return initialState;
        default:
            return state;
    }
};

export default reducer;
